import { T } from '@testout/labsim-ui-atomics';
import * as React from 'react';
import CircleIndeterminateProgress from '../controls/circleindeterminateprogress';
import PageFooter from '../partials/PageFooter';
import styles from './LoadingPage.module.less';
export default class LoadingPage extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            progressTitle: props.progressTitle || 'Loading...',
        };
    }
    render() {
        return (React.createElement("div", { className: styles.container },
            React.createElement(T.Text.H1, { automationId: 'loading', variation: T.Text.Variation.H1_Large }, this.state.progressTitle),
            React.createElement(CircleIndeterminateProgress, null),
            React.createElement(T.Text.Span, { automationId: 'status', className: styles.statusMessage }, this.props.status || ''),
            React.createElement("div", { className: 'spacer' }),
            React.createElement(PageFooter, null)));
    }
}
//# sourceMappingURL=LoadingPage.js.map